export default {
  props: {
    valueOpcaoSelecionadaId: {
      type: Number,
      default: null,
    },
    opcoes: {
      type: Array,
      default: () => [],
    },
  },
}
